module.exports = __webpack_public_path__ + "static/media/julie.138381e5.jpg";